import { render, staticRenderFns } from "./y_choose_cate.vue?vue&type=template&id=69a1f555&scoped=true&"
import script from "./y_choose_cate.vue?vue&type=script&lang=js&"
export * from "./y_choose_cate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a1f555",
  null
  
)

export default component.exports